import { Button, Col, Typography } from "antd";
import React from "react";
import {
  InputSelect,
  InputText,
  SimpleInputSelectMultiple,
} from "../../../../shared/components";
import { SelectedDaysType } from "./RulesFiftyOffForm";
import { useEditRulesSushiLunch, useRulesSushiLunch } from "../../hooks";
import { categoriesService } from "../../../../shared/services";

const { Title } = Typography;

export const EditRulesFiftyOff = ({
  setOpenModalEditRule,
  ruleId,
}: {
  setOpenModalEditRule: (val: boolean) => void;
  ruleId: number;
}) => {
  const [selectedDays, setSelectedDays] = React.useState<string[]>([]);
  const [days, setDays] = React.useState<SelectedDaysType>({
    monday: "false",
    tuesday: "false",
    wednesday: "false",
    thursday: "false",
    friday: "false",
    saturday: "false",
    sunday: "false",
  });

  // Estado para almacenar las categorías
  const [categories, setCategories] = React.useState<
    { value: string; title: string }[]
  >([]);

  const [selectedCategoryIds, setSelectedCategoryIds] = React.useState<string[]>(
    [],
  );

  const { comboRuleById, loading } = useRulesSushiLunch({
    rule_id: ruleId,
  });

  const { editComboRule, control } = useEditRulesSushiLunch({
    setOpenModalEditRule,
    comboRuleById,
    days,
    selectedCategoryIds,
  });

  const handleDaysChange = (values: string[]) => {
    setSelectedDays(values);

    const updatedDays: SelectedDaysType = {
      monday: values.includes("monday") ? "true" : "false",
      tuesday: values.includes("tuesday") ? "true" : "false",
      wednesday: values.includes("wednesday") ? "true" : "false",
      thursday: values.includes("thursday") ? "true" : "false",
      friday: values.includes("friday") ? "true" : "false",
      saturday: values.includes("saturday") ? "true" : "false",
      sunday: values.includes("sunday") ? "true" : "false",
    };
    setDays(updatedDays);
  };

  // Cargar las categorías al montar el componente
  React.useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await categoriesService.find({
          query: {
            $select: ["id", "name"],
            $limit: 999,
          },
        });

        // Formatear las categorías para el componente de selección
        const formattedCategories = response.data.map((cat) => ({
          value: cat.id.toString(),
          title: cat.name,
        }));

        setCategories(formattedCategories);
      } catch (error) {
        console.error("Error al cargar categorías:", error);
      }
    };

    loadCategories();
  }, []);

  React.useEffect(() => {
    if (!comboRuleById) {
      return;
    }

    const activeDays = Object.keys(comboRuleById).filter(
      (day) => comboRuleById[day] === "true",
    );
    setSelectedDays(activeDays);

    const categoryIds =
      comboRuleById.category_ids?.length
        ? comboRuleById.category_ids
        : comboRuleById.apply_to_category_id
          ? [comboRuleById.apply_to_category_id]
          : [];

    setSelectedCategoryIds(categoryIds.map((id) => id.toString()));
  }, [comboRuleById]);

  return (
    <form onSubmit={editComboRule}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Nombre:
        </Title>
        <InputText placeHolder="seguridad" name="name" control={control} />
      </Col>

      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Categorías:
        </Title>
        <SimpleInputSelectMultiple
          label="Selecciona una o más categorías"
          valuesSelect={selectedCategoryIds}
          onChange={setSelectedCategoryIds}
          clearValue={(value: string) =>
            setSelectedCategoryIds(
              selectedCategoryIds.filter((categoryId) => categoryId !== value),
            )
          }
          showSearch={true}
          dataOptions={categories}
        />
      </Col>

      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Días disponibles:
        </Title>
        <SimpleInputSelectMultiple
          label="Selecciona los días"
          onChange={(e) => handleDaysChange(e)}
          valuesSelect={selectedDays}
          clearValue={(value: string) =>
            handleDaysChange(selectedDays.filter((day) => day !== value))
          }
          showSearch={true}
          dataOptions={[
            { title: "Lunes", value: "monday" },
            { title: "Martes", value: "tuesday" },
            { title: "Miércoles", value: "wednesday" },
            { title: "Jueves", value: "thursday" },
            { title: "Viernes", value: "friday" },
            { title: "Sábado", value: "saturday" },
            { title: "Domingo", value: "sunday" },
          ]}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          name="status"
          control={control}
          dataOptions={[
            { title: "Activo", value: "active" },
            { title: "Inactivo", value: "inactive" },
          ]}
          label="Estado"
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
        loading={loading}
      >
        Editar
      </Button>
    </form>
  );
};
